<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/hr/employee">
                    <icon name="users"></icon>
                    พนักงาน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/work-schedule-history">
                    <icon name="calendar-alt"></icon>
                    บันทึกการเปลี่ยนตารางการทำงาน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/rate-salary">
                    <icon name="coins"></icon>
                    บันทึกการปรับเงิน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/hr/sale-bonus">
                    <icon name="cog"></icon>
                    ตั้งค่าโบนัสเซลล์
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "employee-layout"
    }
</script>

<style scoped>

</style>